import { render, staticRenderFns } from "./BaseField.vue?vue&type=template&id=73c77e28&scoped=true"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"
import style0 from "./BaseField.vue?vue&type=style&index=0&id=73c77e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c77e28",
  null
  
)

export default component.exports